export default "__VITE_ASSET__CWnr3TnB__"